import { Menu } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import '../static/css/custom.css';
import {
  UilDashboard,
  UilUpload,
  UilSearch,
  UilFileShieldAlt,
  UilListUl,
  UilSetting,
  UilEllipsisV,
  UilFileEditAlt,
  UilPalette,
} from '@iconscout/react-unicons';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { NavTitle } from './Style';
import { useUser } from '../context/UserContext';
import { getActiveLogo } from '../container/modules/settings/logos/logoService';

function MenuItems({ toggleCollapsed }) {
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  const { userDetails } = useUser();
  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  // const userRole = userDetails?.role || {};
  const userRole = localStorage.getItem('userRole');
  const activeLogo = getActiveLogo();

  const path = `/${userRole}`;

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    getItem(
      !topMenu && (
        <NavTitle className="flex text-[12px] font-medium uppercase text-light mt-[20px] dark:text-white87 p-0">
          {activeLogo.appName}
        </NavTitle>
      ),
      'dms',
      null,
      null,
      'group',
    ),
    (userRole === 'employee' ||
      userRole === 'superadmin' ||
      userRole === 'globaladmin' ||
      userRole === 'supervisor' ||
      userRole === 'processor-1' ||
      userRole === 'processor-2' ||
      userRole === 'receiving-officer') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={path}>
          Dashboard
        </NavLink>,
        'dashboard',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={path}>
            <UilDashboard />
          </NavLink>
        ),
      ),
    (userRole === 'superadmin' ||
      userRole === 'globaladmin' ||
      userRole === 'supervisor' ||
      userRole === 'processor-1' ||
      userRole === 'processor-2') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/upload`}>
          Upload And Encode
        </NavLink>,
        'upload',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={`${path}/pages/upload`}>
            <UilUpload />
          </NavLink>
        ),
      ),
    (userRole === 'superadmin' || userRole === 'globaladmin' || userRole === 'supervisor' || userRole === 'processor-1') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/index-form`}>
          QA Form
        </NavLink>,
        'forms',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={`${path}/pages/index-form`}>
            <UilFileShieldAlt />
          </NavLink>
        ),
      ),
    getItem(
      <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/search`}>
        Search
      </NavLink>,
      'search',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/search`}>
          <UilSearch />
        </NavLink>
      ),
    ),
    (userRole === 'superadmin' ||
      userRole === 'globaladmin' ||
      userRole === 'admin' ||
      userRole === 'supervisor' ||
      userRole === 'employee' ||
      userRole === 'report-viewer') &&
      getItem(
        <NavLink
          className="text-body hover:text-[#039966]"
          onClick={toggleCollapsed}
          to={`${path}/pages/report-generation`}
        >
          Report Generation
        </NavLink>,
        'report-generation',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={`${path}/pages/report-generation`}>
            <UilListUl className="active:text-primary focus:text-primary" />
          </NavLink>
        ),
      ),
    (userRole === 'superadmin' || userRole === 'globaladmin' || userRole === 'supervisor') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/reprocess`}>
          Reprocess
        </NavLink>,
        'reprocess',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={`${path}/pages/reprocess`}>
            <UilUpload />
          </NavLink>
        ),
      ),
    (userRole === 'superadmin' || userRole === 'supervisor') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/cancellation-mngmt`}>
          Cancellation Management
        </NavLink>,
        'cancellation-mngmt',
        !topMenu && (
          <NavLink className="menuItem-iocn" to={`${path}/pages/cancellation-mngmt`}>
            <UilFileEditAlt />
          </NavLink>
        ),
      ),
    (userRole === 'admin' || userRole === 'superadmin' || userRole === 'globaladmin' || userRole === 'supervisor') &&
      getItem(
        <NavLink className="text-body hover:text-[#039966]">Settings</NavLink>,
        'settings',
        !topMenu && <UilSetting />,
        [
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/audit-trail`}
            >
              Audit Trail
            </NavLink>,
            'audit-trail',
            null,
          ),
          getItem(
            <NavLink className="text-body hover:text-[#039966]" onClick={toggleCollapsed} to={`${path}/pages/variables`}>
              Variable Management
            </NavLink>,
            'variable-mngmt',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/operations`}
            >
              Operations Management
            </NavLink>,
            'operations-mngmt',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/user-mngmt`}
            >
              User Management
            </NavLink>,
            'user-mngmt',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/document-info-mngmt`}
            >
              Document Info Management
            </NavLink>,
            'document-info-mngmt',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/form-builder`}
            >
              Form Builder
            </NavLink>,
            'form-builder',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/manage-themes`}
            >
              Manage Themes
            </NavLink>,
            'manage-themes',
            null,
          ),
          getItem(
            <NavLink
              className="text-body hover:text-[#039966]"
              onClick={toggleCollapsed}
              to={`${path}/pages/manage-logo`}
            >
              Manage Logo
            </NavLink>,
            'manage-logo',
            null,
          ),
        ],
      ),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
